/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ModalConfirm, Text } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { PopoverMenuButton } from "~/components/Popover/PopoverMenuButton";
import { showSuccess } from "~/components/Toast";
import { Application } from "~/models";
import { generateActionSuccessText, useAxios } from "~/tools";

type ServiceDeactivateProps = {
  refetch: () => void;
  application: Application;
  setIsPopover: React.Dispatch<React.SetStateAction<boolean>>;
};

function ApplicationRemove({
  refetch,
  application,
  setIsPopover,
}: ServiceDeactivateProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const handleClose = () => {
    setIsPopover(false);
    setIsOpen(false);
  };

  const removeApplication = async () => {
    try {
      await Axios().delete(`/applications/${application.id}`);
      setIsOpen(true);
      refetch();
      showSuccess(
        generateActionSuccessText(`Application ${application.name}`)()(
          "deleted"
        )()
      );
    } catch (e) {
      showError(e.response);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <PopoverMenuButton icon="trash" onClick={() => setIsOpen(true)}>
        Remove
      </PopoverMenuButton>

      <ModalConfirm
        onClose={handleClose}
        isOpen={isOpen}
        confirm={removeApplication}
        actionLabel="Remove"
        contentLabel={`Remove application ${application.name}`}
      >
        <Text color="warning">
          {`Are you sure you want to remove application ${application.name}?`}
        </Text>
      </ModalConfirm>
    </>
  );
}

export { ApplicationRemove };
